import { useCallback } from 'react';
import { AlertType, Icon } from '../../../../components';
import { useToast } from '../../../../hooks';
import { formatDisplayedPhoneNumber } from '../../../../utils';
import HoverableContent from './HoverableContent';

interface SimulationDetailsPhoneNumberProps {
  phoneNumber: string;
}

const SimulationDetailsPhoneNumber = ({ phoneNumber }: SimulationDetailsPhoneNumberProps) => {
  const { showToast } = useToast();

  const handleCopyPhoneNumber = useCallback(() => {
    if (!phoneNumber) return;
    navigator.clipboard.writeText(phoneNumber);
    showToast({ message: 'Phone number copied to clipboard', type: AlertType.SUCCESS });
  }, [phoneNumber, showToast]);

  return (
    <HoverableContent
      icon={Icon.COPY}
      content={formatDisplayedPhoneNumber(phoneNumber)}
      tooltip="Copy phone number"
      onClick={handleCopyPhoneNumber}
    />
  );
};

export default SimulationDetailsPhoneNumber;
